<template>
  <div class="custom_editor">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout v-if="!otpInput" wrap justify-center>
      <v-flex pa-4 xs12 sm12 md6>
        <v-card :outlined="true">
          <v-layout pa-4>
            <v-flex text-left>
              <span style="font-size:16px;font-weight:500">Profile</span>
            </v-flex>
            <v-flex v-if="!editProfile" text-right>
              <v-btn
                text
                class="text-capitalize"
                dark
                style="font-size:14px"
                :ripple="false"
                color="#26af82"
                @click="otpInput=true"
              >Edit</v-btn>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex px-4 pb-4>
              <v-layout align="center" wrap justify-center>
                <v-flex xs12 sm12 md4 text-center py-2>
                  <v-avatar size="100" tile>
                    <v-img
                      v-if="proPicImg"
                      id="proPic"
                      style="border-radius:5px"
                      :src="proPicImg"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      :src="baseURL+'/u/'+profileDat.profilepic"
                      id="proPic"
                      style="border-radius:5px"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                </v-flex>
                <v-flex v-if="editProfile" text-center align-self-center py-2>
                  <span class="px-2">
                    <v-btn
                      rounded
                      small
                      :ripple="false"
                      id="pro_pic"
                      class="text-capitalize"
                      outlined
                      color="#26af82"
                      width="150"
                      @click="$refs.uploadPic.click()"
                    >
                      Change
                      <v-img
                        src="../../assets/icons/upload.png"
                        aspect-ratio="1"
                        contain
                        height="20px"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-btn>
                    <input
                      v-show="false"
                      ref="uploadPic"
                      accept="image/*"
                      type="file"
                      @change="uploadPic"
                    />
                  </span>
                </v-flex>
              </v-layout>
              <v-layout wrap pt-4 align="center">
                <v-flex xs5 sm12 md4 text-left>
                  <span style="color:#6A6A6A;">Username</span>
                </v-flex>
                <v-flex xs7 v-if="!editProfile" text-left>
                  <span style="font-size:16px;color:#090909;">{{userName}}</span>
                </v-flex>
                <v-flex xs6 v-if="editProfile" text-left>
                  <v-text-field
                    ref="userName"
                    v-model="userName"
                    :rules="[rules.required,rules.username]"
                    :error-messages="msg_username"
                    color="#26af82"
                    :autocomplete="false"
                    required
                    height="20"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout wrap pt-4 align="center">
                <v-flex xs5 sm12 md4 text-left>
                  <span style="color:#6A6A6A">Phone Number</span>
                </v-flex>

                <v-flex xs7 v-if="!editProfile" text-left>
                  <span>{{countryCode}}{{ phoneNo}}</span>
                </v-flex>
                <v-flex xs7 v-if="editProfile">
                  <v-layout wrap justify-center>
                    <v-flex xs5 sm3 md3 pl-2>
                      <v-select
                        v-model="countryCode"
                        :items="countryCodes"
                        :rules="[rules.required]"
                        color="#26af82"
                        item-color="#26af82"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex xs7 sm9 md9 pl-0>
                      <v-text-field
                        ref="phoneNo"
                        v-model="phoneNo"
                        :rules="[rules.required,rules.phone]"
                        :error-messages="msg_phoneno"
                        color="#26af82"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout wrap pt-4 align="center">
                <v-flex xs5 sm12 md4 text-left>
                  <span style="color:#6A6A6A">Mail ID</span>
                </v-flex>
                <v-flex xs7 v-if="!editProfile" text-left>
                  <span>{{mailId}}</span>
                </v-flex>
                <v-flex xs6 v-if="editProfile" text-left>
                  <v-text-field
                    ref="mailId"
                    v-model="mailId"
                    :rules="[rules.required,rules.email]"
                    :error-messages="msg_mailId"
                    color="#26af82"
                    required
                    height="20"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout wrap pt-4 align="center">
                <v-flex xs5 sm12 md4 text-left>
                  <span v-if="!editProfile" style="color:#6A6A6A">Password</span>
                  <span v-if="editProfile" style="color:#6A6A6A">New Password</span>
                </v-flex>
                <v-flex xs7 v-if="!editProfile" text-left>
                  <v-layout>
                    <v-flex>
                      <span>●●●●●●●●</span>
                    </v-flex>
                  </v-layout>
                  <v-layout my-n2>
                    <v-flex>
                      <span style="font-size:10px">Last Changed {{passworddate}}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 md6 v-if="editProfile" text-left>
                  <v-text-field
                    autocomplete="off"
                    ref="password"
                    color="#26af82"
                    placeholder="●●●●●●●●"
                    v-model="password"
                    :rules="[rules.min,rules.password]"
                    :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordShow ? 'text' : 'password'"
                    :error-messages="msg_password"
                    @click:append="passwordShow = !passwordShow"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout pa-4 v-if="editProfile" wrap justify-center>
            <v-flex text-right>
              <v-btn
                text
                class="text-capitalize"
                dark
                :ripple="false"
                color="#26af82"
                @click="submit"
              >Submit</v-btn>
              <v-btn
                text
                class="text-capitalize"
                dark
                :ripple="false"
                color="#26af82"
                @click="editProfile=false"
              >Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="otpInput" wrap justify-center>
      <v-flex pa-4 xs12 sm12 md6>
        <v-card :outlined="true">
          <otpReader @stepper="winStepper" />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

import otpReader from "./otpReader";
export default {
  props: ["profileDat"],
  components: {
    otpReader
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      ServerError: false,
      profileData: [],

      userName: null,
      countryCode: null,
      phoneNo: null,
      mailId: null,
      countryCodes: ["+61", "+65", "+91"],
      passworddate: null,

      password: null,
      confPassword: null,
      passwordShow: false,
      passwordShow2: false,

      formHasErrors: false,

      msg_username: null,
      msg_phoneno: null,
      msg_mailId: null,
      msg_password: null,
      err_username: false,
      err_phoneno: false,
      err_mailid: false,
      err_password: false,

      userId: null,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters",
        username: value => value.length >= 4 || "Min 4 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid Mail ID";
        },
        phone: value => {
          const pattern = /^[0-9+]*$/;
          return pattern.test(value) || "Invalid Phone Number";
        },
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
          return (
            pattern.test(value) ||
            "Must contain atleast one uppercase, one lowercase,one digit and one special characters"
          );
        }
      },
      editProfile: false,
      otpInput: false,
      proPicImg: null,
      proPicSts: false
    };
  },
  beforeMount() {
    this.userName = this.profileDat.username;
    this.countryCode = this.profileDat.phonePrefix;
    this.phoneNo = this.profileDat.phone;
    this.mailId = this.profileDat.email;
    this.userId = this.profileDat._id;
    var dt = this.profileDat.log.prevpass1.chagedDate;
    dt = new Date(dt);
    dt = dt.toString();
    dt = dt.slice(4, 15);
    this.passworddate = dt;
    // this.getProfile();
  },
  watch: {
    userName: function() {
      axios({
        method: "GET",
        url: "/user/check/username",
        params: {
          username: this.userName,
          id: this.userId
        }
      })
        .then(response => {
          if (response.data.status == false) {
            this.err_username = true;
            this.msg_username = response.data.msg;
          } else {
            this.err_username = false;
            this.msg_username = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    phoneNo: function() {
      var data = {};
      data["phone"] = this.phoneNo;
      data["prefix"] = this.countryCode;
      data["id"] = this.userId;
      axios({
        method: "POST",
        url: "/user/check/phone",
        data: data
      })
        .then(response => {
          if (response.data.status == false) {
            this.err_phoneno = true;
            this.msg_phoneno = response.data.msg;
          } else {
            this.err_phoneno = false;
            this.msg_phoneno = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    countryCode: function() {
      var data = {};
      data["phone"] = this.phoneNo;
      data["prefix"] = this.countryCode;
      data["id"] = this.userId;
      axios({
        method: "POST",
        url: "/user/check/phone",
        data: data
      })
        .then(response => {
          if (response.data.status == false) {
            this.msg_phoneno = response.data.msg;
            this.err_phoneno = true;
          } else {
            this.formHasErrors = false;
            this.err_phoneno = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    mailId: function() {
      axios({
        method: "GET",
        url: "/user/check/email",
        params: {
          email: this.mailId,
          id: this.userId
        }
      })
        .then(response => {
          if (response.data.status == false) {
            this.err_mailid = true;
            this.msg_mailId = response.data.msg;
          } else {
            this.err_mailid = false;
            this.msg_mailId = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    password: function() {
      axios({
        method: "GET",
        url: "/user/check/password",
        params: {
          password: this.password,
          id: this.userId
        }
      })
        .then(response => {
          if (response.data.status == false) {
            this.err_password = true;
            this.msg_password = response.data.msg;
          } else {
            this.err_password = false;
            this.msg_password = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  },
  computed: {
    form() {
      return {
        userName: this.userName,
        phoneNo: this.phoneNo,
        mailId: this.mailId,
        password: this.password
      };
    }
  },
  methods: {
    winStepper(window_data) {
      this.otpInput = false;
      this.editProfile = window_data.allowEdit;
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.profileData = response.data.data;
          this.userName = response.data.data.username;
          this.countryCode = response.data.data.phonePrefix;
          this.phoneNo = response.data.data.phone;
          this.mailId = response.data.data.email;
          this.userId = response.data.data._id;
          var dt = response.data.data.log.prevpass1.chagedDate;
          dt = new Date(dt);
          dt = dt.toString();
          dt = dt.slice(4, 15);
          this.passworddate = dt;
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    submit() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        if (f == "password" && !this.password) {
          return;
        }
        if (!this.form[f]) {
          this.formHasErrors = true;
        }
        var ret = this.$refs[f].validate(true);
        if (!ret) this.formHasErrors = true;
      });
      if (this.err_username) this.formHasErrors = true;
      if (this.err_phoneno) this.formHasErrors = true;
      if (this.err_mailid) this.formHasErrors = true;
      if (this.err_password) this.formHasErrors = true;
      if (!this.formHasErrors) {
        this.appUpdate();
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
      }
    },
    appUpdate() {
      this.appLoading = true;
      this.profileData = {};
      this.profileData.username = this.userName;
      this.profileData.phonePrefix = this.countryCode;
      this.profileData.phone = this.phoneNo;
      this.profileData.email = this.mailId;
      this.profileData.id = this.userId;
      this.profileData.password = this.password;
      this.profileData.completeprofile = true;
      axios({
        method: "POST",
        url: "/user/Edit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: this.profileData
      })
        .then(response => {
          this.editProfile = false;
          this.password = null;
          this.appLoading = false;
          if (this.proPicSts) {
            this.uploadProPic();
          } else {
            window.location.reload();
          }
          // this.getProfile();
          this.msg = response.data.msg;
          // this.showsnackbar = true;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },

    uploadPic(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.propic = e.target.files[0];
      var reader = new FileReader();
      reader.onload = e => {
        this.proPicImg = e.target.result;
      };
      this.proPicSts = true;
      reader.readAsDataURL(files[0]);
    },

    uploadProPic() {
      this.appLoading = true;
      var formData = null;
      formData = new FormData();
      formData.append("photo", this.propic);
      axios({
        method: "POST",
        url: "/user/profilepic",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        },
        data: formData
      })
        .then(response => {
          this.appLoading = false;
          window.location.reload();
          this.msg = response.data.msg;
          this.showsnackbar = true;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.custom_editor .v-input__slot::before {
  border-style: none !important;
}
.error {
  border: 1px solid red !important;
}
</style>